<script setup>
import getClient from '@/composables/graphql-client.js';
import pagesQuery from '@/queries/pages.gql';
import { useRoute } from 'vue-router';
import formieParams from '@/composables/formieParams.js';
import GoBack from '@/components/go-back.vue';
import useStore from '@/composables/store.js';
import blocks from '@/components/blocks.vue';

const store = useStore();
const route = useRoute();

const client = getClient();

const { data } = await client.executeQuery({
    query: pagesQuery,
    variables: {
        slug: route.params.slug,
        formTemplateOptions: JSON.stringify(formieParams),
        lang: store.lang.value,
    },
});

</script>
<template>
    <main class="page-wrapper min-h-screen bg-charcoal">
        <div v-if="data && data.page" class=" relative z-1 px-8 lg:px-24">
            <div class="rounded-b-3xl bg-lightpeach px-8 py-24 lg:p-24">
                <go-back
                    color="black"
                    size="small"
                    class="sticky top-8 z-10 mb-8 text-current hover:text-white"
                    :class="{'border-current bg-white/30':store.scrollTop.value > 200}"
                />

                <h1 class="mb-7 font-heading text-4xl font-light leading-none lg:text-6xl">
                    {{ data.page.title }}
                </h1>

                <blocks v-if="data?.page?.page?.length > 0" :blocks="data.page.page" />
            </div>
        </div>
    </main>
</template>
